module.exports = __webpack_public_path__ + "static/media/box-white.c58f7b93.svg";